module.exports = __webpack_public_path__ + "assets/img/item05.9303d4a3.svg";